import { APIErrorCode, APIErrorType } from '@/types/api-error';
export var handleError = function handleError(e) {
  return new Error(getAPIErrorType(e));
};
export var getAPIErrorType = function getAPIErrorType(e) {
  return e.code === APIErrorCode.FAIL || e.code === undefined ? APIErrorType.NETWORK_ERROR : APIErrorType.SERVER_ERROR;
};